<template>
    <el-drawer
        custom-class="dap-drawer"
        :visible="visible"
        :show-close="false" :withHeader="false"
        :append-to-body="false"
        :style="{top: `${top}px`, left: `${leftShift}px`, overflow: 'visible'}"
        v-bind="{
            wrapperClosable: false,
            destroyOnClose: true,
            modal: false,
            size: size,
            ...$attrs,
        }"
        v-on="$listeners"
        @close="closeDrawer"
        ref="dapDrawer">
        <div :style="mainStyle" class="drawer-main">
            <div class="drawer-left">
                <div class="close-drawer" @click="closeDrawer">
                    <DapIconSvg class="tab-icon" icon-class="choutifanhui" />
                </div>
                <div
                    class="bindIcon"
                    v-for="(item, index) in filteredOptions"  :key="item.key"
                    :class="current === item.key ? 'active' : ''"
                    @click="tabClick(item.key, index)"
                >
                    <DapIconSvg class="tab-icon" :icon-class="item.icon" />
                    <div class="nav-btn-text f12 c-666">{{ item.name }}</div>
                </div>
            </div>
            <div class="drawer-right">
                <div class="drawer-head">
                    <slot name="drawer-title">
                        <span>{{ drawerTitle }}</span>
                    </slot>
                </div>
                <div class="drawer-body">
                    <slot />
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import DapIconSvg from "../../icon-svg";
export default {
    name:'DapDrawer',
    components: {
        DapIconSvg,
    },
    props: {
        options: {
            type: Array
        },
        visible: {
            type: Boolean,
            default: false
        },
        drawerTitle: {
            type: String,
            default: '标题'
        },
        top: {
            type: String,
            default: '120'
        },
        current:{
            type: [Number, String],
            default: 0,
        },
        size: {
            type: String,
            default: '900px',
        },
    },
    computed: {
        mainStyle () {
            return {
                top: this.top + 'px',
                width: this.width + 'px',
                right: this.visible ? '0' : `-${this.width}+'px`,
                height: document.body.clientHeight - this.top +'px'
            };
        },
        filteredOptions () {
            return this.options.filter(i => !i.hide);
        },
        leftShift () {
            return this.left > 0 ? this.left : 0;
        }
    },
    data () {
        return {
            left: 0,
            isWaiting: false,
        };
    },
    created () {
        this.left = window.document.body.clientWidth - this.size.replace(/px/, '');
        window.addEventListener('resize', () => {
            this.waitFn().then(() => {
                this.left = window.document.body.clientWidth - this.size.replace(/px/, '');
            }).catch(_ => _);
        });
    },
    methods: {
        tabClick (key, index) {
            this.$emit('change', key, index);
        },
        waitFn () {
            return new Promise((resolve, reject) => {
                if (this.isWaiting) {
                    reject();
                    setTimeout(() => {
                        this.isWaiting = false;
                    }, 60);
                    return;
                } else {
                    this.isWaiting = true;
                    resolve();
                    setTimeout(() => {
                        this.isWaiting = false;
                    }, 60);
                }
            });
        },
        closeDrawer () {
            this.$emit('close');
        }
    }
};
</script>

<style lang="scss">
.dap-drawer {
    background: #fff;
    box-shadow: 0 0 8px 0 #F0F0F2;
    .el-drawer__header {
        margin-bottom: 0;
        padding: 0;
    }
    .drawer-main {
        display: flex;
        width: 100%;
    }
    .drawer-left {
        height: 100%;
        width: 40px;
        background: #fff;
        box-sizing: border-box;
        .close-drawer {
            width: 40px;
            height: 40px;
            background: #323437;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            .tab-icon {
                color: #fff;
            }
        }
        .close-drawer:hover {
            opacity: 0.7;
        }
        .bindIcon {
            width: 40px;
            height: 45px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            background: #e5e6e9;
            &.active {
                background: #2f88ff;
                .nav-btn-text {
                    color: #fff !important;
                }
                .tab-icon {
                    color: #fff;
                }
                &:hover {
                    opacity: 1;
                }
            }
        }
        .bindIcon:hover {
            opacity: 0.7;
        }
        .tab-icon {
            width: 26px;
            height: 26px;
        }
    }
    .drawer-right {
        height: 100%;
        flex: auto;
        overflow: hidden;
    }
    .drawer-head {
        display: flex;
        justify-content: space-between;
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        font-size: 14px;
        border-bottom: 1px solid #e4e9ed;
    }
    .drawer-body {
        height: calc(100% - 40px);
        overflow-y: auto;
        box-sizing: border-box;
        background: #f0f0f2;
    }
}
</style>
